exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".taxi-marker>.bubble{background:#f58200;border:none;border-radius:4px;padding:5px 10px}.taxi-marker span{font-family:\"Visby-CF-Bold\", Arial;font-size:17px;color:#fff}.taxi-marker>.arrow-down{width:0;height:0;border:solid;border-width:12px 4px 0 4px;margin:auto;border-color:#f58200 transparent transparent transparent}\n", ""]);

// exports
